module.exports = __webpack_public_path__ + "static/img/light.d95b63f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/light.png
// module id = hsQ6
// module chunks = 7